<template>
  <Dashboard
    v-if="loaded"
    :stats="stats"
    :user-title="me.full_name" />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import store from './_store';
import Dashboard from './_components/Dashboard';

export default {
  name: 'DashboardModule',
  components: {
    Dashboard,
  },
  beforeCreate() {
    this.$store.registerModule('$_dashboard', store);
  },
  destroyed() {
    this.$store.unregisterModule('$_dashboard');
  },
  async created() {
    if (this.hasAdminRole) {
      this.usersCount = String(await this.fetchUsersCount());
      this.contactMessagesCount = String(await this.fetchContactMessagesCount());
      this.bookingRequestsCount = String(await this.fetchBookingRequestsCount());
    }
    this.loaded = true;
  },
  data() {
    return {
      loaded: true,
      usersCount: '--',
      contactMessagesCount: '--',
      bookingRequestsCount: '--',
    };
  },
  computed: {
    ...mapState('me', {
      me: state => state.account,
    }),
    ...mapGetters('me', [
      'hasAdminRole',
    ]),
    stats() {
      let stats = [
        {
          title: this.bookingRequestsCount,
          subtitle: 'Booking Requests',
          type: 'danger',
          icon: 'tim-icons icon-calendar-60',
          link: '/booking-requests',
        },
        {
          title: this.contactMessagesCount,
          subtitle: 'Contact Messages',
          type: 'warning',
          icon: 'tim-icons icon-email-85',
          link: '/contact-messages',
        },
        {
          title: this.usersCount,
          subtitle: 'Users',
          type: 'info',
          icon: 'tim-icons icon-single-02',
          link: '/users',
        },
      ];
      if (!this.hasAdminRole) {
        const adminRoleStats = ['/users', '/contact-messages'];
        stats = stats.filter(stat => adminRoleStats.indexOf(stat) !== -1);
      }

      return stats;
    },
  },
  methods: {
    ...mapActions('$_dashboard', [
      'fetchUsersCount',
      'fetchContactMessagesCount',
      'fetchBookingRequestsCount',
    ]),
  },
};
</script>
